import { GROUP_AREAS, GROUP_IMAGES, GROUP_TIPPING } from "../../../const/URL.const";
import { ITabs } from "../../ordersSetting/types";

export const groupSettingTabs: ITabs = {
  direction: "column",
  tabs: [
    {
      key: "GENERAL",
      title: "groups.groupSettingTabs.general",
    },
    {
      key: "AREAS",
      title: "groups.groupSettingTabs.groupAreas",
    },
    {
      key: "TIPPING",
      title: "groups.groupSettingTabs.groupTipping",
    },
    {
      key: "IMAGES",
      title: "groups.groupSettingTabs.groupImages",
    },
  ],
};

export const tabURLS: Record<string, string> = {
  "AREAS": GROUP_AREAS,
  "TIPPING": GROUP_TIPPING,
  "IMAGES": GROUP_IMAGES,
  "GENERAL": ""
}